module.exports = __webpack_public_path__ + "static/media/oval-capital.9a03d004.png";